<app-storyblok-root
  [story]="story$ | async"
  [overlayNav]="overlayNav$ | async"
  [prefooter]="prefooter$ | async"
  [extraDataMap]="extraDataMap$ | async"
></app-storyblok-root>
